import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DevAuthService } from 'src/app/core/auth/dev-auth.service';
import { IonicModule } from '@ionic/angular';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Shown when the API responds 403 to an /api/developer/... call (see AuthInterceptor) —
 * every one of those routes requires the same Entwicklerplattform permission, so a 403
 * there always means the logged-in tenant member has no Developer Platform access at all,
 * not a narrower per-action restriction.
 */
@Component({
    selector: 'app-access',
    templateUrl: './access.page.html',
    styleUrls: ['./access.page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        IonicModule,
        RouterLink,
        TranslatePipe,
    ],
})
export class AccessPage {
  constructor(public auth: DevAuthService) { }
}
